define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/table/Delete",
    "csi/widget/MessageDialog"
], function(declare,lang,Delete,MessageDialog) {

    return declare(Delete, {
        /**
         * @override
         * Return resource to use for "Yes" button in confirmation dialog
         */
        getConfirmButton: function() {
            return MessageDialog.BUTTON_REMOVE;
        }
    });
});